// Account phone numbers in the accounts list (pages/account-management.tsx): what is
// sent and stored is digits only; dashes are for the screen.
//
// The page had two functions named formatPhoneNumber — a module-level one returning
// digits, and one inside the component returning "519-555-0110" that shadowed it. The
// Group Accounts dialog kept the dashed form in its state and posted it as-is, so a
// group's parent and every grouped location stored "519-555-0110" while every other
// account held "5195550110". The server normalizes too (storage.ts), but the dialog
// sends digits on its own.

/**
 * A phone as the digits stored on an account: non-digits dropped, an 11-digit number's
 * leading country code 1 dropped (so "+1 519 555 0110" pasted in is "5195550110"), and
 * at most 10 digits — the length the account dialogs accept.
 */
export function phoneDigits(value: string | null | undefined): string {
  let digits = (value ?? "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  return digits.slice(0, 10);
}

/** Digits shown as "519-555-0110" while they are typed ("519-5", "519-555-01"). Display only. */
export function dashedPhone(value: string | null | undefined): string {
  const digits = phoneDigits(value);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** The body of the Group Accounts dialog's POST /api/accounts/group. */
export function groupAccountsBody(parentName: string, phone: string, childAccountIds: number[]) {
  return { parentName, phone: phoneDigits(phone), childAccountIds };
}
